const emMagLock = {
  name: 'Door with mag lock',
  value: 1,
  relayTime: 6,
};

const strikeLock = {
  name: 'Door with strike lock',
  value: 2,
  relayTime: 6,
};

const boomBarierSlidingGate = {
  name: 'Boom Barrier or Sliding Gate',
  value: 3,
  relayTime: 2,
};

const flapTurnstileBarriers = {
  name: 'Flap or Tunstile Barrier',
  value: 4,
  relayTime: 2,
};

export const NEW_INSTALL_CONFIGS = [
  {
    name: 'Entry + Exit reader (RS485 Disabled)',
    value: 1,
    formOptions: {
      entry: true,
      exit: true,
      control: false,
      lockingMechanism: true,
      relayTime: true,
      attendanceAvailable: true,
      doorSensor: true
    },
    validSerials: {
      entry: [
        '1001',
        '1002',
        '1015',
        '101F',
        '1023',
        '1024',
        '1025',
        '1028',
        '1029',
        '1033',
        '1034',
        '1038',
        '103A',
        '103D',
        '102E',
        '103F',
        '1042',
        '102F',
      ],
      exit: [
        '1001',
        '1002',
        '1015',
        '101F',
        '1023',
        '1024',
        '1025',
        '1028',
        '1029',
        '1033',
        '1034',
        '1038',
        '103A',
        '103D',
        '102E',
        '103F',
        '1042',
        '102F',
      ],
      control: [],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
      boomBarierSlidingGate: boomBarierSlidingGate,
      flapTurnstileBarriers: flapTurnstileBarriers,
    },
  },
  {
    name: 'Entry + Exit reader (RS485 Enabled)',
    value: 7,
    formOptions: {
      entry: true,
      exit: true,
      control: false,
      lockingMechanism: true,
      relayTime: true,
      attendanceAvailable: true,
      doorSensor: true
    },
    validSerials: {
      entry: ['1028', '1029', '1001', '103A', '103F', '1042',],
      exit: ['1028', '1029', '1001', '103A', '103F', '1042',],
      control: [],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
      boomBarierSlidingGate: boomBarierSlidingGate,
      flapTurnstileBarriers: flapTurnstileBarriers,
    },
  },
  {
    name: 'Entry reader and REX',
    value: 2,
    formOptions: {
      entry: true,
      exit: false,
      control: false,
      lockingMechanism: true,
      relayTime: true,
      attendanceAvailable: false,
      doorSensor: true
    },
    validSerials: {
      entry: [
        '1001',
        '1002',
        '1015',
        '101F',
        '1023',
        '1024',
        '1025',
        '1028',
        '1029',
        '1033',
        '1034',
        '1038',
        '103A',
        '103D',
        '102E',
        '103F',
        '1042',
        '102F',
      ],
      exit: [],
      control: [],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
      boomBarierSlidingGate: boomBarierSlidingGate,
    },
  },
  // {
  //   name: 'Entry reader and 1-door controller',
  //   value: 'entryReaderAnd1DoorController',
  //   formOptions: {
  //     entry: true,
  //     exit: false,
  //     control: true,
  //     lockingMechanism: true,
  //     relayTime: true,
  //     attendanceAvailable: false,
  //   },
  //   validSerials: {
  //     entry: ['1001', '1002', '1015', '101F', '1023', '1028'],
  //     exit: [],
  //     control: ['1027'],
  //   },
  //   lockingMech: {
  //     emMagLock: emMagLock,
  //     strikeLock: strikeLock,
  //   },
  // },
  // {
  //   name: '1-door controller and REX',
  //   value: '1DoorControllerAndRex',
  //   formOptions: {
  //     entry: false,
  //     exit: false,
  //     control: true,
  //     lockingMechanism: true,
  //     relayTime: true,
  //     attendanceAvailable: false,
  //   },
  //   validSerials: {
  //     entry: [],
  //     exit: [],
  //     control: ['1027'],
  //   },

  //   lockingMech: {
  //     emMagLock: emMagLock,
  //     strikeLock: strikeLock,
  //   },
  // },
  {
    name: 'Clock-in device',
    value: 5,
    formOptions: {
      entry: true,
      exit: false,
      control: false,
      lockingMechanism: false,
      relayTime: false,
      attendanceAvailable: false,
      doorSensor: false
    },
    validSerials: {
      entry: [
        '1001',
        '1015',
        '101F',
        '1023',
        '1024',
        '1025',
        '1028',
        '1029',
        '1033',
        '1034',
        '103A',
        '1038',
        '103D',
        '102E',
        '103F',
        '1042',
        '102F',
      ],
      exit: [],
      control: [],
    },
    lockingMech: {},
  },
  {
    name: 'Door Lock',
    value: 6,
    formOptions: {
      entry: true,
      exit: false,
      control: false,
      lockingMechanism: false,
      relayTime: true,
      attendanceAvailable: false,
      doorSensor: false
    },
    validSerials: {
      entry: ['1016', '1021', '1026', '1032', '103B'],
      exit: [],
      control: [],
    },
    lockingMech: {},
  },
];

export const RETROFIT_TYPE1_CONFIGS = [
  {
    name: 'Entry reader and REX',
    value: 2,
    formOptions: {
      entry: true,
      exit: false,
      control: false,
      lockingMechanism: false,
      relayTime: false,
      attendanceAvailable: false,
      doorSensor: false
    },
    validSerials: {
      entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '103F', '1042',],
      exit: [],
      control: [],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
      boomBarierSlidingGate: boomBarierSlidingGate,
      flapTurnstileBarriers: flapTurnstileBarriers,
    },
  },
  {
    name: 'Entry and Exit reader',
    value: 1,
    formOptions: {
      entry: true,
      exit: true,
      control: false,
      lockingMechanism: false,
      relayTime: false,
      attendanceAvailable: false,
      doorSensor: false
    },
    validSerials: {
      entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '103F', '1042',],
      exit: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '103F', '1042',],
      control: [],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
      boomBarierSlidingGate: boomBarierSlidingGate,
    },
  },
];

export const CONTROLLER_CONFIGS = [
  {
    name: 'Entry Reader + Door Controller',
    value: 3,
    formOptions: {
      entry: true,
      exit: false,
      control: true,
      lockingMechanism: true,
      relayTime: true,
      attendanceAvailable: false,
    },
    validSerials: {
      entry: ['1001', '1002', '1015', '101F', '1023', '1028'],
      exit: [],
      control: ['1027'],
    },
    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
    },
  },
  {
    name: 'Door Controller + REX',
    value: 4,
    formOptions: {
      entry: false,
      exit: false,
      control: true,
      lockingMechanism: true,
      relayTime: true,
      attendanceAvailable: false,
    },
    validSerials: {
      entry: [],
      exit: [],
      control: ['1027'],
    },

    lockingMech: {
      emMagLock: emMagLock,
      strikeLock: strikeLock,
    },
  },
];

export const CONTROLLER_LOCKING_MECHANISMS = [
  { name: 'Door with mag lock', value: 1 },
  {
    name: 'Door with strike lock',
    value: 2,
  },
];

export const controllerSerialConfigs = ['1027', '102C'];

export const ENTRY_ONLY = {
  name: 'Entry Only',
  value: 2,
  formOptions: {
    entry: true,
    exit: false,
    control: false,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '1002', '102E', '103F', '1042', '102F',],
    exit: [],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const ENTRY_EXIT = {
  name: 'Entry + Exit',
  value: 1,
  formOptions: {
    entry: true,
    exit: true,
    control: false,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: true,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '102E', '103F', '1042', '102F',],
    exit: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '102E', '103F', '1042', '102F',],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
  },
};

export const ENTRY_ONLY_OTHERS = {
  name: 'Entry Only',
  value: 2,
  formOptions: {
    entry: true,
    exit: false,
    control: false,
    lockingMechanism: false,
    relayTime: false,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '102E', '103F', '1042', '102F',],
    exit: [],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const ENTRY_EXIT_OTHERS = {
  name: 'Entry + Exit',
  value: 1,
  formOptions: {
    entry: true,
    exit: true,
    control: false,
    lockingMechanism: false,
    relayTime: false,
    attendanceAvailable: true,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '102E', '103F', '1042', '102F',],
    exit: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1025', '103D', '102E', '103F', '1042', '102F',],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
  },
};

export const ENTRY_ONLY_AZURE_ZKTECO = {
  name: 'Entry Only',
  value: 3,
  formOptions: {
    entry: true,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  //  formOptions: {
  //   entry: true,
  //   exit: false,
  //   control: true,
  //   lockingMechanism: true,
  //   relayTime: true,
  //   attendanceAvailable: true,
  //   doorSensor: true,
  // },
  skipSerialValidations: true,
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '103F', '1042',],
    exit: [],
    control: ['1039', '1040', '103C'],
    '1039': 4
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const ENTRY_EXIT_AZURE_ZKTECO = {
  name: 'Entry + Exit',
  value: 10,
  formOptions: {
    entry: true,
    exit: true,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: true,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '103F', '1042',],
    exit: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '103F', '1042',],
    control: ['1039', '1040', '103C'],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
  },
};

export const CONTROLLER_THIRD_PARTY_READER_AZURE_ZKTECO = {
  name: 'Controller + Third Party Reader',
  value: 8,
  formOptions: {
    entry: false,
    exit: false,
    control: true,
    lockingMechanism: false,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  skipSerialValidations: true,
  validSerials: {
    entry: [],
    exit: [],
    control: [],
    '1039': 4
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const ENTRY_EXIT_CONTROLLER = {
  name: 'Entry + Exit Controller',
  value: 7,
  formOptions: {
    entry: true,
    exit: true,
    control: false,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: true,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '103A', '1015', '1038', '103F', '1042',],
    exit: ['1028', '1029', '1001', '103A', '1038', '103F', '1042',],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const CLOCK_IN = {
  name: 'Clock In',
  value: 5,
  formOptions: {
    entry: true,
    exit: false,
    control: false,
    lockingMechanism: false,
    relayTime: false,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: [
      '1001',
      '1015',
      '101F',
      '1023',
      '1024',
      '1025',
      '1028',
      '1029',
      '1033',
      '1034',
      '103A',
      '1038',
      '103D',
      '102D',
      '102E',
      '103F',
      '1042',
      '102F',
    ],
    exit: [],
    control: [],
  },
  lockingMech: {},
};

export const DOOR_LOCK = {
  name: 'Door Lock',
  value: 6,
  formOptions: {
    entry: true,
    exit: false,
    control: false,
    lockingMechanism: false,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: ['1016', '1021', '1026', '1032', '103B'],
    exit: [],
    control: [],
  },
  lockingMech: {},
};

export const CONTROLLER_ONLY_SPINTLY = {
  name: 'Controller only',
  value: 4,
  formOptions: {
    entry: false,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: [],
    exit: [],
    control: ['1027'],
  },

  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
  },
};

export const ENTRY_ONLY_CONTROLLER_SPINTLY = {
  name: 'Entry Only',
  value: 3,
  formOptions: {
    entry: true,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: ['1001', '1002', '1015', '101F', '1023', '1028', '1038', '103A', '103F', '1042',],
    exit: [],
    control: ['1027'],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
  },
}

export const REX_CONTROLLER_SPINTLY = {
  name: 'REX only',
  value: 4,
  formOptions: {
    entry: false,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: [],
    exit: [],
    control: ['1027'],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
  },
}

export const THIRD_PARTY_SPINTLY = {
  name: 'Third Party Reader',
  value: 8,
  formOptions: {
    entry: false,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: [],
    exit: [],
    control: ['1027'],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
  },
}

export const ENTRY_ONLY_ISTAR = {
  name: 'Entry Only',
  value: 3,
  formOptions: {
    entry: true,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  //  formOptions: {
  //   entry: true,
  //   exit: false,
  //   control: true,
  //   lockingMechanism: true,
  //   relayTime: true,
  //   attendanceAvailable: true,
  //   doorSensor: true,
  // },
  skipSerialValidations: true,
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015'],
    exit: [],
    control: ['1039', '1040', '103C', '1041'],
    '1039': 4
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const READER_WITH_CHANNEL_EXTENDER = {
  name: 'Reader + Channel Extender (R+ChEx)',
  value: 9,
  formOptions: {
    entry: true,
    exit: false,
    control: false,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: true,
  },
  validSerials: {
    entry: ['1028', '1029', '1001', '101F', '1023', '1028', '1033', '1034', '103A', '1038', '1015', '1025', '103D', '1002', '102E', '103F', '1042', '102F',],
    exit: [],
    control: [],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
    boomBarierSlidingGate: boomBarierSlidingGate,
    flapTurnstileBarriers: flapTurnstileBarriers,
  },
};

export const ENTRY_ONLY_DCS = {
  name: 'Entry Only',
  value: 11,
  formOptions: {
    entry: true,
    exit: false,
    control: true,
    lockingMechanism: true,
    relayTime: true,
    attendanceAvailable: false,
    doorSensor: false,
  },
  validSerials: {
    entry: ['1001', '1002', '1015', '101F', '1023', '1028', '1038', '103A', '103F', '1042',],
    exit: [],
    control: ['1027'],
  },
  lockingMech: {
    emMagLock: emMagLock,
    strikeLock: strikeLock,
  },
}

export const WITHOUT_CONTROLLER_CONFIGS = [ENTRY_ONLY, ENTRY_EXIT, ENTRY_EXIT_CONTROLLER, CLOCK_IN, DOOR_LOCK, READER_WITH_CHANNEL_EXTENDER];
// export const SPINTLY_CONTROLLER_CONFIGS = [CONTROLLER_ONLY_SPINTLY, ENTRY_ONLY_CONTROLLER_SPINTLY];
export const SPINTLY_CONTROLLER_CONFIGS = [ENTRY_ONLY_CONTROLLER_SPINTLY, REX_CONTROLLER_SPINTLY, THIRD_PARTY_SPINTLY];
export const AZURE_ZKTECO_CONTROLLER_CONFIGS = [ENTRY_ONLY_AZURE_ZKTECO, ENTRY_EXIT_AZURE_ZKTECO]; //REMOVED ENTRY_EXIT FOR THIS PHASE, DO NOT REMOVE REQUIRED FOR NEXT PHASE
export const ISTAR_CONTROLLER_CONFIGS = [ENTRY_ONLY_ISTAR];
// export const AZURE_ZKTECO_CONTROLLER_CONFIGS = [ENTRY_ONLY_AZURE_ZKTECO, CONTROLLER_THIRD_PARTY_READER_AZURE_ZKTECO];
// export const OTHERS_CONTROLLER_CONFIGS = [ENTRY_ONLY_OTHERS, ENTRY_EXIT_OTHERS]; //REMOVED ENTRY_EXIT FOR THIS PHASE, DO NOT REMOVE REQUIRED FOR NEXT PHASE
export const OTHERS_CONTROLLER_CONFIGS = [ENTRY_ONLY_OTHERS];
export const DCS_CONTROLLER_CONFIGS = [ENTRY_ONLY_DCS];


